import React from 'react';
import styles from './styles.module.css';

const Layout = ({ left, right }) => (
  <div className={styles.root}>
    {left}
    <div className={styles.content}>{right}</div>
  </div>
);

export default Layout;
